var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-panel",
    { attrs: { "header-text": _vm.formStructure.caption } },
    [
      _c(
        "q-form",
        {
          ref: _vm.formStructure.key,
          staticClass: "q-detail-form",
          attrs: {
            model: _vm.model,
            rules: _vm.rangeRules,
            "label-width": "120px",
          },
        },
        [
          _c("q-form-generator", {
            attrs: { "form-structure": _vm.formStructure },
            model: {
              value: _vm.model,
              callback: function ($$v) {
                _vm.model = $$v
              },
              expression: "model",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.readonly,
              expression: "!readonly",
            },
          ],
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "q-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.persist()
                },
              },
            },
            [_c("span", [_vm._v(_vm._s(_vm.$qt("model.okButtonText")))])]
          ),
          _vm._v(" "),
          _c(
            "q-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.readonly,
                  expression: "!readonly",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.reject()
                },
              },
            },
            [_c("span", [_vm._v(_vm._s(_vm.$qt("model.rejectButtonText")))])]
          ),
          _vm._v(" "),
          _c(
            "q-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.readonly,
                  expression: "!readonly",
                },
              ],
              attrs: { type: "danger" },
              on: {
                click: function ($event) {
                  return _vm.deleteModel()
                },
              },
            },
            [_c("span", [_vm._v(_vm._s(_vm.$qt("model.deleteButtonText")))])]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("model.deleteDialog.title"),
            width: "30%",
            visible: _vm.deleteDialogVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteDialogVisible = $event
            },
          },
        },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.$qt("model.deleteDialog.warningNote"))),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                { attrs: { type: "danger" }, on: { click: _vm.deleteModel } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$qt("model.deleteDialog.confirm")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  attrs: { type: "inverse" },
                  on: {
                    click: function ($event) {
                      _vm.deleteDialogVisible = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$qt("model.deleteDialog.cancel")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }